<template>
  <div class="page">
    <el-form
            v-if="isSearch"
            :model="queryForm"
            ref="form"
            label-width="80px"
            :inline="true"
            size="small"
            class="query-form"
            @submit.native.prevent
        >
          <el-form-item label="所属账号">
                <GridSelectU style="width: 200px;" title="选择所属账号" labelName="userName"
                             labelValue="id" :value="queryForm.userId" :limit='1' size='small'
                             placeholder='请选择所属账号'
                             @getValue="getSearchValueUser" :columns="USER_code" :searchs="USER_search"
                             dataListUrl="/mpp/user/findList" entityBeanName="mppUser"
                             queryEntityUrl="/mpp/user/get">
                </GridSelectU>
            </el-form-item>
         <el-form-item label="营业执照名称" label-width="120px">
                 <el-input v-model="queryForm.licenseName" placeholder="请输入营业执照名称" style="width: 180px"></el-input>
            </el-form-item>
         <el-form-item label="营业执照编号" label-width="120px">
                 <el-input v-model="queryForm.licenseNumber" placeholder="请输入营业执照编号" style="width: 180px"></el-input>
            </el-form-item>
           <el-form-item label="组织类型">
                <el-select clearable v-model="queryForm.orgType" style="width: 100px;">
                    <el-option v-for="(item,index) in storeOrgTypeStatusEunmList" :key="index" :value="item.value" :label="item.label"></el-option>
                </el-select>
            </el-form-item>
   
           <el-form-item label="签约状态">
                <el-select clearable v-model="queryForm.signStatus" style="width: 100px;">
                    <el-option v-for="(item,index) in signStatusList" :key="index" :value="item.value" :label="item.label"></el-option>
                </el-select>
            </el-form-item>
          
            <el-form-item label="法人姓名">
                <el-input v-model="queryForm.personName" placeholder="请输入姓名" style="width: 100px"></el-input>
            </el-form-item>
            <el-form-item label="法人手机号" label-width="100px"  >
                <el-input v-model="queryForm.personMobile" placeholder="请输入手机号" style="width: 180px"></el-input>
            </el-form-item>
            <el-form-item label="是否推送">
                 <el-select v-model="queryForm.isUpdated" clearable placeholder="是否推送" style="width: 180px">
                        <el-option
                        v-for="item in isUpdatedList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        />
                    </el-select>
            </el-form-item>
            <el-form-item label="进件状态">
                 <el-select v-model="queryForm.thirdPartyType" clearable placeholder="进件状态" style="width: 180px">
                        <el-option
                        v-for="item in thirdPartyTypeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        />
                    </el-select>
            </el-form-item>
            <el-form-item label="支付宝认证状态" label-width="120px">
                 <el-select v-model="queryForm.alipayStatusKf" clearable placeholder="支付宝认证状态" style="width: 120px">
                        <el-option
                        v-for="item in alipayStatusKfList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        />
                    </el-select>
            </el-form-item>
            <el-form-item label="微信认证状态" label-width="120px">
                 <el-select v-model="queryForm.wxpayStatusKf" clearable placeholder="微信认证状态" style="width: 120px">
                        <el-option
                        v-for="item in wxpayStatusKfList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        />
                    </el-select>
            </el-form-item>
            <el-form-item label="申请单号">
                 <el-input v-model="queryForm.registerIdKf" placeholder="请输入申请单号" style="width: 180px"></el-input>
            </el-form-item>
            <el-form-item label="商户号">
                <el-input v-model="queryForm.subAccountKf" placeholder="请输入商户号" style="width: 180px"></el-input>
            </el-form-item>
            <el-form-item style="margin-left: 80px">
                <el-button size="small" type="primary" icon="el-icon-search" @click="getBrandList">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
    <div class="page-content">
      <div class="page-tool-bar">
        <div class="operation">
        </div>
        <div class="icon-group">
            <span title="搜索" class="icon-box" @click="search">
                <Icon color="#606266">
                    <Search />
                </Icon>
            </span>
            <span class="icon-box" @click="refreshShopMoneyFlowList">
                <Icon color="#606266">
                    <Refresh />
                </Icon>
            </span>
        </div>
      </div>
      <!-- 列表数据 -->
      <el-table
        height='100%'
        :data="shopBrandList"
        row-key="id"
        @selection-change="handleSelectionChange"
        size="small"
        border
        v-loading="loading"
      >
       <el-table-column
                    fixed="left"
                    align="center"
                    type="selection"
                    width="60"
       ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="orgType"
          label="组织类型"
          width="100px"
        >
        <template slot-scope="scope">
           <el-tag type="warning" v-if="scope.row.orgType == 1">小微</el-tag>
           <el-tag  v-if="scope.row.orgType == 2">企业</el-tag>
           <el-tag type="danger" v-if="scope.row.orgType == 3">个体</el-tag>

        </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="licenseName"
          label="营业执照名称"
          width="200px"
        >
        </el-table-column>
        <!-- <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="licenseNumber"
          label="营业执照号码"
          width="200px"
        > 
       </el-table-column> -->
         <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="signStatus"
          label="签约状态"
          width="100px"
        >
        <template slot-scope="scope">
            <!-- 签约状态,1:WAIT-未签约:2:DOING-签约中3:SUCCESS-签约成功4:FAIL-签约失败 -->
          <el-tag v-if="scope.row.signStatus == 1">未签约</el-tag>
          <el-tag v-if="scope.row.signStatus == 2" type="warning">签约中</el-tag>
          <el-tag v-if="scope.row.signStatus == 3" type="success">签约成功</el-tag>
          <el-tag v-if="scope.row.signStatus == 4" type="danger">签约失败</el-tag>
        </template>
        </el-table-column>
          <el-table-column
             align="center"
             prop="fastMsg"
             label="进件失败描述"
             width="200px"
           >
       </el-table-column>
       <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="thirdPartyType"
          label="进件状态"
          width="100px"
        >
        <template slot-scope="scope">
            <div style="color: #f4a715;" v-if="scope.row.thirdPartyType == 1"> 
                  待进件
            </div>
            <div style="color: coral;"   v-if="scope.row.thirdPartyType == 2">
                 渠道审核
            </div>
            <div style="color: #44c90d;" v-if="scope.row.thirdPartyType == 3"> 
                 进件成功
            </div>
            <div style="color: crimson;" v-if="scope.row.thirdPartyType == 4"> 
                 进件失败
            </div>
        </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="personName"
          label="法人姓名"
          width="100px"
        >
       </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="personMobile"
          label="法人手机"
          width="100px"
        >
       </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="isUpdated"
          label="是否推送"
          width="100px"
        >
        <template slot-scope="scope">
            <div> 
                {{ scope.row.isUpdated == 0 ? '未推送' : '已推送' }}
            </div>
        </template>
       </el-table-column>
 
       <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="alipayStatusKf"
          label="支付宝认证状态"
          width="100px"
        >
        <template slot-scope="scope">
            <!-- 支付宝认证 1.已认证 0.未认证 -->
            <div> 
                  {{alipayStatusKfAdd(scope.row.alipayStatusKf ) }}
            </div>
        </template>
         </el-table-column>
       <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="wxpayStatusKf"
          label="微信认证状态"
          width="100px"
        >
        <template slot-scope="scope">
            <div> 
                {{ wxpayStatusKfAdd(scope.row.wxpayStatusKf) }}
            </div>
        </template>
       </el-table-column>
         <el-table-column
             :show-overflow-tooltip="true"
             align="center"
             prop="registerIdKf"
             label="申请单号"
             width="150px"
          >
       </el-table-column>
       <el-table-column
             :show-overflow-tooltip="true"
             align="center"
             prop="subAccountKf"
             label="商户号"
             width="150px"
          >
       </el-table-column>
      
       <el-table-column align="center" label="操作" width="300" fixed="right">
            <template slot-scope="scop">
                 <div class="operation">
                    
                    <div class="primary" type="primary" @click="quickPaymentForIncomingItems(scop.row)">查看</div>
                    <div class="primary" style="background-color: #f4a715 ;" type="warning" @click="quickPaymentForIncomingModifications(scop.row)">修改信息</div>
                  
                    <div class="primary" type="primary" @click="authenticationQuery(scop.row)">进件结果查询</div>
                    <div class="primary" style="background-color: #44c90d;" type="primary" @click="authenticationQuery(scop.row)">微信认证查询</div>
                    <div class="primary" style="background-color: #44c90d;" type="primary" @click="authenticationQueryPz(scop.row)">微信配置查询</div>
                    <div class="primary" type="primary" @click="authenticationQuery(scop.row)">支付宝认证查询</div>
                    <div v-if="scop.row.thirdPartyType == 1 " class="primary" @click="incoming(scop.row)" style="background-color:  #ee1313fa;">
                              快付进件
                    </div>
                    <div v-if=" scop.row.thirdPartyType == 4 " class="primary" @click="entryModification(scop.row)" style="background-color:  #f06c36ed;">
                             快付进件修改
                     </div>       
                      <div class="primary danger" style="background-color: #da1d1ded;" @click="deleteShopBrand(scop.row)">删除</div>   
                </div>
            </template>
        </el-table-column>
      </el-table>
      <div class="pagination-box">
        <el-pagination
          @size-change="sizeChange"
          @current-change="currentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
          background
          :pager-count="7"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 详情 -->
      <quickPayment v-if="drawer" :orgObj="orgObj" :storeObj="storeObj"   :drawer="drawer" :title="title"  @updateDrawer="updateDrawer" :disabled="disabled" ></quickPayment>
  </div>  
</template>

<script>
import { Refresh,  Search } from '@v2icons/tabler';
import { get, post, deleteFun, upload ,postJson } from '@/utils/request.js';
import { UPLOAD_API, UPLOAD_PATH, USER, USER_SEARCH } from '@/utils/constant';
import axios from 'axios';
import quickPayment  from './common/quickPayment.vue'
import GridSelectU from '@/components/gridselect/index.vue';
export default {
   components: {
    Refresh,
    Search,
    quickPayment,
    GridSelectU
  },  
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetShopBrandList();
                this.getBrandList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetShopBrandList();
                this.getBrandList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            USER_code: USER,
            USER_search: USER_SEARCH,
            title: "进件详情",
            drawer: false,
            queryForm: {
                  licenseName: "",
                  userId:"",//用户ID
                  licenseNumber: "",
                  storeId: "",//门店ID
                  orgType: "", //组织类型：1小微 2企业 3个体
                  personName: "", //法人姓名
                  personMobile: "", //法人手机
                  isUpdated: null, //是否推送,0:未推送,1:已推送
                  thirdPartyType: null, //STATUS_1(1, "待进件"), STATUS_2(2, "渠道审核"), STATUS_3(3, "进件成功"), STATUS_4(4, "进件失败")
                  alipayStatusKf: null, //支付宝认证 1.已认证 0.未认证
                  wxpayStatusKf: null, //微信认证 1.已认证 0.未认证
                  registerIdKf: "", //申请单号
                  subAccountKf: "", //商户号
                  signStatus: "", //签约状态
                  licenseName:"", //营业执照名称
                  licenseNumber:"", //营业执照编号
                 },
            storeOrgTypeStatusEunmList: [ 
                {
                    value: 1,
                    label: '小微',
                },
                {
                    value: 2,
                    label: '企业',
                },
                {
                    value: 3,
                    label: '个体',
                }
            ],
            signStatusList:[
                {
                    value: 1,
                    label: '未签约',
                },
                {
                    value: 2,
                    label: '签约中',
                },
                {
                    value: 3,
                    label: '签约成功',
                },
                {
                    value: 4,
                    label: '签约失败',
                }
            ],
            isUpdatedList:[
                 {
                    value: '0',
                    label: '未推送',
                },
                {
                    value: '1',
                    label: '已推送',
                }
            ],
            thirdPartyTypeList: [
                {
                    value: '1',
                    label: '待进件',
                },
                {
                    value: '2',
                    label: '渠道审核',
                },
                {
                    value: '3',
                    label: '进件成功',
                },
                {
                    value: '4',
                    label: '进件失败',
                }
            ],
            // 支付宝支付认证状态
            alipayStatusKfList: [
                
                {
                    value: '0',
                    label: '受理中',
                },
                {
                    value: '1',
                    label: '审核中',
                },
                {
                    value: '3',
                    label: '待联系人确认',
                },
                {
                    value: '4',
                    label: '待法人确认',
                },
                {
                    value: '5',
                    label: '审核通过',
                },
                {
                    value: '6',
                    label: '审核驳回',
                },
                {
                    value: '7',
                    label: '已冻结',
                },
                {
                    value: '8',
                    label: '已撤回',
                },
                {
                    value: '9',
                    label: '联系人处理中',
                },
                {
                    value: '10',
                    label: '已销户',
                },
                {
                    value: '11',
                    label: '未完成确认',
                },
                {
                    value: '12',
                    label: '已完成确认'
                }
                
            ],
           
            // 微信认证状态
            wxpayStatusKfList: [
                 {
                    value: '0',
                    label: '受理中',    
                },
                {
                    value: '1',
                    label: '审核中',
                },
                {
                    value: '2',
                    label: '编辑中',
                },
                {
                    value: '3',
                    label: '带确认联系信息',
                },
                {
                    value: '4',
                    label: '待账户验证',
                },
                {
                    value: '5',
                    label: '审核通过',
                },
                {
                    value: '6',
                    label: '审核驳回',
                },
                {
                    value: '7',
                    label: '已冻结',
                },
                {
                    value: '8',
                    label: '已作废',
                },
                {
                    value: '9',
                    label: '未授权',
                },
                {
                    value: '10',
                    label: '已授权',
                }
            ],
            timeRange: [],
            loading: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            multipleSelection: [],
            shopBrandList: [],//列表数据
            groupValue: [],
            waitMoney:null,
            orgObj: {}, // 组织信息
            storeObj: {}, // 店铺信息
            disabled: true,
        };
    },
    mounted() {
        this.getBrandList();
    },
    methods: {
        updateDrawer(val) {
            this.drawer = val;
           this.getBrandList();
        },
        getSearchValueUser(val){
            this.queryForm.userId = val;
           },
              //快付进件
        incoming(row){
            this.$confirm('确认要进行快付进件吗?', '提示', {
                type: 'warning'
            }).then(()=>{
                get('/shop/store/fastRegister',{storeId : row.storeId}).then(res=>{
                      if(res.success){
                          this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                       this.getBrandList()
                    }
                })
            })
        },
        //快付进件修改
        entryModification(row){
            this.$confirm('确认要修改快付进件吗?', '提示', {
                type: 'warning'
            }).then(()=>{
                get('/shop/store/fastRegisterUpdate',{storeId : row.storeId}).then(res=>{
                      if(res.success){
                          this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                       this.getBrandList()
                    }
                })
            })
        },
        isThirdPartyType(row){
            switch (row) {
                case 'STATUS_1':
                case 1:
                    return '待进件';
                case 'STATUS_2':
                case 2:
                    return '渠道审核';
                case 'STATUS_3':
                case 3: 
                    return '进件成功';
                case 'STATUS_4':
                case 4:
                    return '进件失败';
                default:
                    return '';
            }
        },
        alipayStatusKfAdd(row){
            switch (row) {
                case 0:
                return '受理中';
                case 1:
                    return '审核中';
                case 2:
                    return '编辑中';
                case 3:
                    return '待联系人确认';
                case 4:
                    return '待法人确认';
                case 5:
                    return '审核通过';
                case 6:
                    return '审核驳回';  
                case 7:
                    return '已冻结';
                case 8:
                    return '已撤回';    
                case 9:
                    return '联系人处理中';
                case 10:
                    return '已销户';
                case 11:
                    return '未完成确认';
                case 12:
                    return '已完成确认';    

                default:
                    return '--';
            }
        },
        wxpayStatusKfAdd(row){
            switch (row) {  
                case 0:
                    return '受理中';
                case 1:
                    return '审核中';
                case 2:
                    return '编辑中';
                case 3:
                    return '待确认联系信息';
                case 4:
                    return '待账户验证';
                case 5:
                    return '审核通过';
                case 6:
                    return '审核驳回';
                case 7:
                    return '已冻结';
                case 8:
                    return '已作废';
                case 9:
                    return '未授权';
                case 10:
                    return '已授权';
                default:
                    return '--';
            }
        },
       refreshShopMoneyFlowList() {
            this.resetShopBrandList();
            this.getBrandList();
        },
        thousandSeparator(value) {
            if (!value && value !== 0) return '';
                const num = Number(value);
                if (isNaN(num)) return value;

                // 如果大于等于1000，使用千分位格式化
                if (num >= 1000) {
                return num.toLocaleString('en-US');
                }
                return num;
        },
        search() {
            this.isSearch = !this.isSearch;
        },
        resetShopBrandList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.shopBrandList = [];
        },
      
        refreshShopBrandList() {
            this.resetShopBrandList();
            this.getBrandList();
        },
        resetDialog() {
            this.queryForm = {
                  licenseName: "",
                  userId:"",//用户ID
                  licenseNumber: "",
                  storeId: "",
                  orgType: "", //组织类型：1小微 2企业 3个体
                  personName: "", //法人姓名
                  personMobile: "", //法人手机
                  isUpdated: null, //是否推送,0:未推送,1:已推送
                  thirdPartyType: null, //STATUS_1(1, "待进件"), STATUS_2(2, "渠道审核"), STATUS_3(3, "进件成功"), STATUS_4(4, "进件失败")
                  alipayStatusKf: null, //支付宝认证 1.已认证 0.未认证
                  wxpayStatusKf: null, //微信认证 1.已认证 0.未认证
                  registerIdKf: "", //申请单号
                  subAccountKf: "", //商户号
                  signStatus: "", //签约状态
            };
            this.resetShopBrandList();
            this.getBrandList();
        },
        // 列表数据请求
        getBrandList() {
                this.loading = true;
                  axios({
                    method: 'post',
                    url: '/shop/store/findAll',
                    data: {
                         ...this.queryForm,
                         pageSize: this.pageSize,
                         pageNum: this.currentPage
                    },
                }).then(res => {
                    this.loading = false;
                    if (res.data.data.searchCount) {
                        this.shopBrandList = res.data.data.records
                        this.totalNum = res.data.data.total

                    }else{
                        this.$message.error(res.data.msg);

                    }
                })
            
        },
        incomingData(row){
             get('/shop/store/findById',{
                storeId: row.storeId
                // storeId: 'ec7ced954ca640d186296eafbb795153'
            }).then((res)=>{
                if(res.code == 200){
                    this.orgObj = res.data.org
                    this.storeObj = res.data.store
                }
            })
        },
        quickPaymentForIncomingItems(row){
            // 只需要在父组件引入子组件的标签中加个 v-if，当这个数据有值的时候才加载子组件 
                         

            this.incomingData(row)
            this.disabled = true
            this.drawer = true
        },
        // 修改
        quickPaymentForIncomingModifications(row){
               this.incomingData(row)
               this.disabled = false
               this.drawer = true
        },
        deleteShopBrand(row){
             this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            }).then(() => {
                    get('/shop/store/deleteByStoreId',{storeId:row.storeId}).then(res=>{ 
                          if(res.code == 200){
                            this.refreshShopBrandList()
                            this.getBrandList()
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                        }
                    })
                })
           },
         authenticationQuery(row){
               get('/shop/storeorginfo/merchantRegister',{orgInfoId:row.id}).then(res=>{
                     if(res.success){
                        this.$message({
                            message: res.msg,
                            type: 'info',
                            duration: 2000
                        });
                     }else{
                        this.$message({
                            message: res.msg,
                            type: 'danger',
                            duration: 2000
                        });
                    }       
               })
           },
           authenticationQueryPz(row){
                  get('/shop/storeorginfo/wxConfig',{orgInfoId:row.id}).then(res=>{
                     if(res.success){
                        this.$message({
                            message: res.msg,
                            type: 'info',
                            duration: 2000
                        });
                     }else{
                        this.$message({
                            message: res.msg,
                            type: 'danger',
                            duration: 2000
                        });
                    }       
               })
           },
        resetQueryFrom() {
            this.getBrandList();
        },
        
        handleSelectionChange(value) {
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getBrandList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getBrandList();
        },
    }
};
</script>

<style lang="scss" scoped>



::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-evenly;
    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }
    .primary{
        background-color: #409eff;
        color: #fff;
        border-radius: 4px;
        height: 28px;
        line-height: 28px;
        margin-top: 15px;
    }
    .danger{
        background-color: #f56c6c;
        color: #fff;
        border-radius: 4px;
        height: 28px;
        line-height: 28px;
    }
}
::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 178px;
    height: 178px;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 178px;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
.logo-img {
    margin-left: 50%;
    transform: translate(-50%, 0);
}
.count{
    margin-right:1.5625vw;
}
</style>
